<template>
    <div class="row">
        <div class="col-md-12">
            <label>{{ tra.do_you_need_yes_need_insurance }}</label>
            <span v-if="postErrors.insurance && !insuranceChecker" class="h6 text-danger">
                ( {{ postErrors.insurance[0] }} )
            </span>
            <br />
        </div>
        <div class="col-md-6">
            <div class="form-check form-check-inline mr-0 ml-4">
                <input 
                    :value="insuranceChecker"
                    @change="$emit('update-insurance-checker', $event.target.value)"
                    name="insurance" 
                    type="radio"
                    style="height: 20px; width: 20px;" 
                    id="insurance-yes" 
                    value="1"
                    :class="(postErrors.insurance && !insuranceChecker ? 'is-invalid' : '') + ' form-check-input mr-0 ml-3 bg-secondary'" 
                />
                <label class="form-check-label" for="insurance-yes">
                    {{ tra.yes }} ({{ dataObj.insurance || 0 }}
                    <span class="small text-dark">
                        {{ (dataObj.currency?.code || 'SAR') == 'SAR' ? ' ' : (dataObj.currency?.code || 'SAR') }}
                    </span>)
                </label>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-check form-check-inline mr-0 ml-4">
                <input 
                    :value="insuranceChecker"
                    @change="$emit('update-insurance-checker', $event.target.value)"
                    name="insurance" 
                    type="radio"
                    style="height: 20px; width: 20px;" 
                    id="insurance-no" 
                    value="0"
                    :class="(postErrors.insurance && !insuranceChecker ? 'is-invalid' : '') + ' form-check-input mr-0 ml-3 bg-secondary'" 
                />
                <label class="form-check-label" for="insurance-no">{{ tra.no }}</label>
            </div>
        </div>
        <div class="col-12">
            <hr class="my-2">
        </div>
    </div>
</template>

<script>
export default {
    name: 'InsuranceSection',
    props: {
        dataObj: Object,
        insuranceChecker: [String, Number],
        postErrors: Object,
        tra: Object,
    },
    emits: ['update-insurance-checker'],
};
</script>